import { Controller } from "@hotwired/stimulus"
import {
  browserTimeZone,
  calendarTimeZone,
  calendarTimeZoneCity,
  calendarTimeZoneOffsetLabel,
  calendarTimeZonePrompt,
  dismissCalendarTimeZonePrompt,
  setCalendarTimeZone
} from "@appComponents/helpers/full-calendar-default-config"

export default class extends Controller {
  static targets = ["message", "useBrowser", "keepCurrent"]
  static values = {
    prompt: String,
    useBrowser: String,
    keepCurrent: String
  }

  connect () {
    const prompt = calendarTimeZonePrompt()
    if (!prompt) return

    const browserZone = this.zoneLabel(prompt.browser)
    const currentZone = this.zoneLabel(prompt.current)

    this.messageTarget.textContent = this.interpolate(this.promptValue, {
      browser_zone: browserZone,
      current_zone: currentZone
    })
    this.useBrowserTarget.textContent = this.interpolate(this.useBrowserValue, { zone: browserZone })
    this.keepCurrentTarget.textContent = this.interpolate(this.keepCurrentValue, { zone: currentZone })
    this.element.classList.remove("d-none")
  }

  useBrowser () {
    setCalendarTimeZone(browserTimeZone())
    dismissCalendarTimeZonePrompt()
    window.location.reload()
  }

  keepCurrent () {
    setCalendarTimeZone(calendarTimeZone())
    dismissCalendarTimeZonePrompt()
    this.element.classList.add("d-none")
  }

  zoneLabel (timeZone) {
    return `${calendarTimeZoneCity(timeZone)} (${calendarTimeZoneOffsetLabel(new Date(), timeZone)})`
  }

  interpolate (template, vars) {
    return Object.entries(vars).reduce(
      (text, [key, value]) => text.replaceAll(`%{${key}}`, value),
      template
    )
  }
}
